import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import bind from "memoize-bind";

import {
  SubBar,
  MainView,
  SidebarView,
  ReviewsList,
  Button,
  PaginationNavigation,
  Message,
} from "lib/components/index";
import {
  stateSelector,
  initializeView,
  destroyView,
  setParamsWithLocationQuery,
  changePagination,
  fetchRecords,
} from "./index";

@connect(
  (state) => ({
    allRecords: stateSelector(state).allRecords.model,
    fetchDone: stateSelector(state).allRecords.fetchDone,
    fetchLoading: stateSelector(state).allRecords.fetchLoading,
    fetchFailed: stateSelector(state).allRecords.fetchFailed,
    offset: stateSelector(state).offset,
    limit: stateSelector(state).limit,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        initializeView,
        destroyView,
        setParamsWithLocationQuery,
        changePagination,
        fetchRecords,
      },
      dispatch
    )
)
export default class ReviewsListView extends React.PureComponent {
  componentDidMount() {
    this.props.initializeView();
    this.props.setParamsWithLocationQuery(this.props.location.query);
  }

  componentWillUnmount() {
    this.props.destroyView();
  }

  render() {
    const {
      fetchRecords,
      fetchDone,
      fetchLoading,
      fetchFailed,
      allRecords,
      offset,
      limit,
      changePagination,
    } = this.props;

    const records = (allRecords && allRecords.records) || [];
    const totalCount = (allRecords && allRecords.meta && allRecords.meta.total_count) || 0;

    return (
      <MainView.Container>
        <SubBar>
          <div className="pull-left">
            <h1>{I18n.t("papp.reviews.ReviewsListView.title")}</h1>
          </div>
          <div className="pull-right">
            {fetchDone && totalCount > 0 && (
              <PaginationNavigation
                offset={offset}
                limit={limit}
                totalCount={totalCount}
                onChange={changePagination}
                name="reviewsLimit"
              />
            )}
          </div>
        </SubBar>

        <MainView.Content grayBackground hasSubBar>
          <MainView.Dimmer loading={fetchLoading} failed={fetchFailed} retry={fetchRecords} />

          {fetchDone && totalCount === 0 && (
            <MainView.DimmerContent
              icon="sentiment_neutral"
              title={I18n.t("papp.reviews.ReviewsListView.no_records_title")}
            >
              <p>{I18n.t("papp.reviews.ReviewsListView.no_records_message")}</p>
            </MainView.DimmerContent>
          )}

          {fetchDone && records.length > 0 && <ReviewsList reviews={records} />}
        </MainView.Content>
      </MainView.Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/reviews/ReviewsListView/ReviewsListView.jsx